"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentSubject = void 0;
var DocumentSubject;
(function (DocumentSubject) {
    DocumentSubject[DocumentSubject["Driver"] = 0] = "Driver";
    DocumentSubject[DocumentSubject["Vehicle"] = 1] = "Vehicle";
    DocumentSubject[DocumentSubject["LegalPerson"] = 2] = "LegalPerson";
    DocumentSubject[DocumentSubject["NaturalPerson"] = 3] = "NaturalPerson";
    DocumentSubject[DocumentSubject["DriversCompany"] = 4] = "DriversCompany";
    DocumentSubject[DocumentSubject["CompanyDriver"] = 5] = "CompanyDriver";
    DocumentSubject[DocumentSubject["Soletrader"] = 6] = "Soletrader";
})(DocumentSubject || (exports.DocumentSubject = DocumentSubject = {}));
//# sourceMappingURL=DocumentSubject.js.map